import { IContentState } from "./interfaces";

export const DEFAULT_CONTENT_STATE: IContentState = {
	activeContents: [],
};
